var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgNorwegian = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 640 480"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#ed2939",
  d: "M0 0h640v480H0z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M180 0h120v480H180z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 180h640v120H0z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#002664",
  d: "M210 0h60v480h-60z"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#002664",
  d: "M0 210h640v60H0z"
})));
export { SvgNorwegian as ReactComponent };
export default __webpack_public_path__ + "assets/images/norwegian.df74d1848911aeb5b580ddb39cbecbe3.svg";